import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithRedirect,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  setPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  collection,
  writeBatch,
  query,
  getDocs,
  orderBy,
} from "firebase/firestore";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import axios from "axios";

const baseUrl = "https://us-central1-blog-content-ai.cloudfunctions.net/api";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const firebaseClient = firebase.initializeApp(firebaseConfig);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account",
});

export const auth = getAuth();
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const signInWithGoogleRedirect = () =>
  signInWithRedirect(auth, provider);

export const db = getFirestore();

export const createUserDocumentFromAuth = async (
  userAuth,
  additionalInformation
) => {
  if (!userAuth) return;
  const userDocRef = doc(db, "users", userAuth.uid);
  const userSnapshot = await getDoc(userDocRef);
  if (!userSnapshot.exists()) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();
    try {
      await setDoc(userDocRef, {
        displayName,
        email,
        createdAt,
        // tokens: { available: 10000, date: createdAt },
        downloads: { used: 0, date: createdAt },
        ...additionalInformation,
      });
    } catch (err) {
      console.error("error creating the user", err.message);
    }
  }
  return userDocRef;
};

export const createAuthUserWithEmailandPassword = async (email, password) => {
  if (!email || !password) return;

  return await createUserWithEmailAndPassword(auth, email, password);
};

export const signInAuthUserWithEmailAndPassword = async (email, password) => {
  if (!email || !password) return;

  return await signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = async () => {
  await signOut(auth);
  localStorage.setItem("token", "");
};

export const onAuthStateChangedListener = (callback) =>
  onAuthStateChanged(auth, callback);

export const persistantSignInWithEmailAndPassword = async (email, password) => {
  if (!email || !password) return;
  await setPersistence(auth, inMemoryPersistence);
  return await signInAuthUserWithEmailAndPassword(email, password);
};

// article firebase code

// export const addCollectionAndDocuments = async (collectionKey, articleToAdd) => {
//   const collectionRef = collection(db, collectionKey);
//   const batch = writeBatch(db);
//   const docRef = doc(collectionRef, articleToAdd.title.toLowerCase());
//     batch.set(docRef, object);

//   await batch.commit();
//   console.log("done");
// };

// code to get user tokens after usage
export const getUserData = async (auth, userIsPremium) => {
  const currentDateMonth = new Date().getMonth();
  const userDocRef = doc(db, "users", auth.uid);
  const userSnapshot = await getDoc(userDocRef);
  const userData = userSnapshot.data();
  const subscriptionSnapshot = await getDocs(
    collection(db, "users", auth.uid, "subscriptions")
  );
  let subscriptionData = [];
  subscriptionSnapshot.forEach((doc) => subscriptionData.push(doc.data()));
  subscriptionData.sort((a,b) => b.created - a.created);
  if (userData) {
    const databaseDateMonth = new Date(userData.downloads.date).getMonth()
    if (userIsPremium && databaseDateMonth !== currentDateMonth) {
      // reset downloads used
  
      const response = await axios.put(baseUrl + `/users/${auth.uid}/downloads`, {
        reset: true,
      });
      userData.downloads.used = 0;
    }
  }
  return { userData: userData, subscriptions: subscriptionData };
};

// export const updateUserTokens = async (tokens) => {
//   console.log(auth);
//   const response = await axios.put(baseUrl + `/users/${auth.lastNotifiedUid}/balance`, {
//     value: tokens,
//   });
//   return response
// };

export const updateDownloadsInDb = async () => {
  // console.log(auth);
  const response = await axios.put(
    baseUrl + `/users/${auth.lastNotifiedUid}/downloads`
  );
  return response;
};
